export const version = "1.7.19";
export const channel = "core";
export const gitcommit = "unknown";
